import { render, staticRenderFns } from "./ItemDrawer.vue?vue&type=template&id=464a1529&scoped=true"
import script from "./ItemDrawer.vue?vue&type=script&lang=js"
export * from "./ItemDrawer.vue?vue&type=script&lang=js"
import style0 from "./ItemDrawer.vue?vue&type=style&index=0&id=464a1529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464a1529",
  null
  
)

export default component.exports